module.exports = __webpack_public_path__ + "img/69.17e3868a.jpg";